<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">To the Last Extremity</h1>
<p class="title1"><span class="bold">The Battles for Charleston, 1776–1782</span></p>
<p class="aut">by Mark Maloy</p>
<div class="img_containert">
<img alt="images" src="images/tit.jpg" style="width:35%;"/>
</div>
<div class="img_containert1">
<img alt="images" src="images/tit1.jpg" style="width:10%;"/>
</div>
<p class="edi">Savas Beatie</p>
<p class="edi1">California</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?4e96dba4